module.exports = __webpack_public_path__ + "static/img/化妆品.9f36732e.png";